import { render, staticRenderFns } from "./env.vue?vue&type=template&id=48d7b832&scoped=true"
import script from "./env.vue?vue&type=script&lang=js"
export * from "./env.vue?vue&type=script&lang=js"
import style0 from "./env.vue?vue&type=style&index=0&id=48d7b832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d7b832",
  null
  
)

export default component.exports